module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "kpiCopyModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.KCM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.KCM001))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.showModal) ? _c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "kpiCopyModal-source-project-select",
      "placeholder": _vm.lang.KCM002,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedSourceProject),
      callback: function($$v) {
        _vm.selectedSourceProject = $$v
      },
      expression: "selectedSourceProject"
    }
  }, _vm._l((_vm.projects), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                " + _vm._s(project.ProjectName) + "\n              ")])
  }), 0) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.KCM003))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.showModal) ? _c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "kpiCopyModal-targetpoject-select",
      "placeholder": _vm.lang.KCM004,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedTargetProject),
      callback: function($$v) {
        _vm.selectedTargetProject = $$v
      },
      expression: "selectedTargetProject"
    }
  }, _vm._l((_vm.projects), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                " + _vm._s(project.ProjectName) + "\n              ")])
  }), 0) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.KCM005) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedSourceProject || !_vm.selectedTargetProject
    },
    on: {
      "click": function($event) {
        return _vm.copyKpis()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.KCM006) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b633ede","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KPIManagement/KPICopyModal.vue
// module id = 601
// module chunks = 1 2